export var Void = {
    'zh-CN': {
        title: '虚拟容器',
    },
    'en-US': {
        title: 'Void',
    },
};
